module.exports = __webpack_public_path__ + "media/img/Landing_Page/Scholarships2u_Feature-Testimonial_Naava-Low-364ace5a113b1dd6d9f08ecac2f97514.jpg";